// src/components/Landing/AboutUs.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './AboutUs.css';

const AboutUs = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page">
      {/* Header Navigation */}
      <nav className="about-nav">
        <div className="about-nav-content">
          <Link to="/" className="about-logo">
            <img src="/logolandingpage.png" alt="CripSYS Logo" />
          </Link>
          <Link to="/" className="about-back-btn">
            <svg viewBox="0 0 24 24" width="20" height="20">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            <span>Voltar ao Site</span>
          </Link>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-content">
          <h1>Sobre a CripSYS</h1>
          <p>Revolucionando a gestão de restaurantes, bares e cafés com tecnologia e inteligência.</p>
          <div className="about-hero-stats">
            <div className="about-stat">
              <span className="about-stat-number">85%</span>
              <span className="about-stat-label">Redução em Tempo Gasto</span>
            </div>
            <div className="about-stat">
              <span className="about-stat-number">33%</span>
              <span className="about-stat-label">Redução Média de Custos</span>
            </div>
            {/* === NOVO BLOCO DE AUTORIDADE ADICIONADO AQUI === */}
            <div className="about-stat">
              <span className="about-stat-number">20%</span>
              <span className="about-stat-label">Aumento Médio no Faturamento</span>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main className="about-content">
        <div className="about-container">
          {/* Table of Contents */}
          <aside className="about-toc">
            <h3>Navegação</h3>
            <ul>
              <li><a href="#mission">Nossa Missão</a></li>
              <li><a href="#story">Nossa História</a></li>
              <li><a href="#values">Nossos Valores</a></li>
              <li><a href="#technology">Nossa Tecnologia</a></li>
              <li><a href="#team">Nossa Equipe</a></li>
              <li><a href="#achievements">Conquistas</a></li>
              <li><a href="#future">Visão de Futuro</a></li>
              <li><a href="#contact">Contato</a></li>
            </ul>
          </aside>

          {/* About Content */}
          <article className="about-article">
            <section id="mission" className="about-section">
              <h2>NOSSA MISSÃO</h2>
              <div className="about-mission-content">
                <div className="about-mission-main">
                  <h3>Simplificar a Gestão do Food Service</h3>
                  <p>
                    Acreditamos que todo dono de restaurante, bar ou café merece ter controle total sobre sua operação sem a complexidade de sistemas tradicionais. Nossa missão é oferecer uma plataforma única e intuitiva que centraliza a gestão de comandas, estoque, vendas e finanças.
                  </p>
                  <p>
                    Transformamos dados operacionais em insights claros, permitindo que nossos clientes tomem decisões mais inteligentes, reduzam custos e tenham mais tempo para focar no que realmente importa: a experiência do cliente.
                  </p>
                </div>
                
                <div className="about-mission-cards">
                  <div className="about-mission-card">
                    <div className="about-card-icon">🎯</div>
                    <h4>Foco no Cliente</h4>
                    <p>Desenvolvemos soluções pensando nos desafios reais dos donos de estabelecimentos de food service.</p>
                  </div>
                  <div className="about-mission-card">
                    <div className="about-card-icon">🚀</div>
                    <h4>Inovação Contínua</h4>
                    <p>Utilizamos inteligência artificial para automatizar tarefas como cadastro de cardápio e notas fiscais.</p>
                  </div>
                  <div className="about-mission-card">
                    <div className="about-card-icon">🤝</div>
                    <h4>Parceria de Sucesso</h4>
                    <p>Somos mais que um sistema; somos parceiros no crescimento e na eficiência dos nossos clientes.</p>
                  </div>
                </div>
              </div>
            </section>

            <section id="story" className="about-section">
              <h2>NOSSA HISTÓRIA</h2>
              <div className="about-story">
                <div className="about-story-content">
                  <h3>Da Necessidade à Inovação</h3>
                  <p>
                    A CripSYS nasceu da observação direta das dores de donos de food services, que passavam horas em planilhas, lidavam com múltiplos sistemas que não conversavam entre si e perdiam dinheiro por falta de controle de estoque e dados imprecisos.
                  </p>
                  <p>
                    Iniciamos nossa jornada para criar uma solução completa que resolvesse esses problemas de forma integrada. Desde o controle de comandas na mesa até o relatório de DRE, nosso objetivo sempre foi fornecer uma ferramenta poderosa, mas que fosse, acima de tudo, fácil de usar. Hoje, ajudamos estabelecimentos a se tornarem mais eficientes, lucrativos e preparados para o futuro.
                  </p>
                </div>
              </div>
            </section>

            <section id="values" className="about-section">
              <h2>NOSSOS VALORES</h2>
              <div className="about-values">
                <div className="about-values-grid">
                  <div className="about-value-card">
                    <div className="about-value-icon">💡</div>
                    <h3>Simplicidade e Usabilidade</h3>
                    <p>
                      Acreditamos que a tecnologia deve simplificar, não complicar. Criamos interfaces intuitivas para que qualquer pessoa possa gerenciar seu negócio com eficiência, sem precisar de manuais.
                    </p>
                  </div>
                  <div className="about-value-card">
                    <div className="about-value-icon">📊</div>
                    <h3>Decisões Baseadas em Dados</h3>
                    <p>
                      "Achismo" não gera lucro. Fornecemos dashboards e relatórios claros que transformam dados brutos em informações valiosas para decisões estratégicas e certeiras.
                    </p>
                  </div>
                  <div className="about-value-card">
                    <div className="about-value-icon">🤖</div>
                    <h3>Inovação com Propósito</h3>
                    <p>
                      Usamos Inteligência Artificial para automatizar tarefas manuais e repetitivas, liberando o tempo dos nossos clientes para que eles possam focar no crescimento do negócio.
                    </p>
                  </div>
                  <div className="about-value-card">
                    <div className="about-value-icon">❤️</div>
                    <h3>Atendimento Humanizado</h3>
                    <p>
                      Por trás da nossa tecnologia, há uma equipe de especialistas pronta para ajudar. Oferecemos suporte gratuito e dedicado para garantir o sucesso de cada cliente.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section id="technology" className="about-section">
              <h2>NOSSA TECNOLOGIA</h2>
              <div className="about-technology">
                <div className="about-tech-intro">
                  <h3>Uma Plataforma Robusta e Integrada</h3>
                  <p>
                    Construímos a CripSYS com foco em performance e usabilidade, garantindo uma solução completa para a gestão do seu estabelecimento.
                  </p>
                </div>
                
                <div className="about-tech-stack">
                  <div className="about-tech-category">
                    <h4>⚙️ Gestão Centralizada</h4>
                    <div className="about-tech-items">
                      <span className="about-tech-item">PDV Balcão / Mesa</span>
                      <span className="about-tech-item">Comandas Inteligentes</span>
                      <span className="about-tech-item">Cardápio Digital</span>
                       <span className="about-tech-item">Painel KDS (Cozinha)</span>
                    </div>
                  </div>
                  <div className="about-tech-category">
                    <h4>🗄️ Controle e Finanças</h4>
                    <div className="about-tech-items">
                      <span className="about-tech-item">Estoque por Ingredientes</span>
                      <span className="about-tech-item">CMV Real e Estimado</span>
                      <span className="about-tech-item">Relatórios DRE</span>
                      <span className="about-tech-item">Integração NFC-e/NF-e</span>
                    </div>
                  </div>
                  <div className="about-tech-category">
                    <h4>📊 Dashboard</h4>
                    <div className="about-tech-items">
                      <span className="about-tech-item">Faturamento por Dia da Semana</span>
                      <span className="about-tech-item">Faturamento por Hora</span>
                      <span className="about-tech-item">Fluxo de Chegada de Clientes</span>
                      <span className="about-tech-item">Lista Completa de Itens Vendidos</span>
                      <span className="about-tech-item">Desempenho da Equipe</span>
                      <span className="about-tech-item">Controle de Ponto</span>
                    </div>
                  </div>
                  <div className="about-tech-category">
                    <h4>🤖 Inteligência Artificial</h4>
                    <div className="about-tech-items">
                      <span className="about-tech-item">Cadastro de Cardápio por IA</span>
                      <span className="about-tech-item">Leitura de Nota Fiscal por IA</span>
                      <span className="about-tech-item">Relatórios Diários no WhatsApp</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section id="team" className="about-section">
              <h2>NOSSA EQUIPE</h2>
              <div className="about-team">
                <div className="about-team-intro">
                  <h3>Apaixonados por Gastronomia e Tecnologia</h3>
                  <p>
                    Nossa equipe combina expertise em desenvolvimento de software, design de experiência do usuário e um profundo conhecimento do setor de food service.
                  </p>
                </div>
                <div className="about-team-departments">
                  <div className="about-department">
                    <h4>💻 Desenvolvimento e Inovação</h4>
                      <p>Engenheiros focados em criar uma plataforma estável, rápida e com funcionalidades que realmente fazem a diferença no dia a dia da operação.</p>
                  </div>
                  <div className="about-department">
                    <h4>🎨 Design e UX</h4>
                      <p>Designers obcecados em criar uma experiência de usuário fluida e intuitiva, transformando processos complexos em ações simples na tela.</p>
                  </div>
                   <div className="about-department">
                    <h4>🤝 Sucesso do Cliente</h4>
                      <p>Especialistas que entendem os desafios do setor e estão sempre prontos para ajudar na configuração, treinamento e uso da plataforma, garantindo que nossos clientes extraiam o máximo valor do CripSYS.</p>
                  </div>
                </div>
              </div>
            </section>

            <section id="achievements" className="about-section">
              <h2>NOSSOS RESULTADOS</h2>
              <div className="about-achievements">
                <div className="about-achievements-grid">
                   <div className="about-achievement-card">
                    <div className="about-achievement-number">3X</div>
                    <h4>Mais Informações</h4>
                    <p>Nossos clientes têm 3x mais dados para tomar decisões estratégicas e certeiras.</p>
                  </div>
                  <div className="about-achievement-card">
                    <div className="about-achievement-number">25%</div>
                    <h4>Aumento na Fidelidade</h4>
                    <p>Aumento médio na recorrência e fidelidade dos clientes com nossas ferramentas de gestão.</p>
                  </div>
                   <div className="about-achievement-card">
                    <div className="about-achievement-number">99.9%</div>
                    <h4>Disponibilidade</h4>
                    <p>Nossa plataforma robusta garante que seu negócio nunca pare de operar, mesmo nos horários de pico.</p>
                  </div>
                   <div className="about-achievement-card">
                    <div className="about-achievement-number">2M+</div>
                    <h4>Comandas Processadas</h4>
                    <p>Milhões de pedidos gerenciados com sucesso, agilidade e sem erros através do nosso sistema.</p>
                  </div>
                  <div className="about-achievement-card">
                    <div className="about-achievement-number">15%</div>
                    <h4>Redução de Desperdício</h4>
                    <p>Otimização do controle de estoque que leva a uma redução significativa no desperdício de insumos.</p>
                  </div>
                   <div className="about-achievement-card">
                    <div className="about-achievement-number">100%</div>
                    <h4>Conformidade Fiscal</h4>
                    <p>Garanta a conformidade fiscal do seu negócio com a emissão automatizada de NFC-e.</p>
                  </div>
                </div>
              </div>
            </section>

            <section id="future" className="about-section">
              <h2>VISÃO DE FUTURO</h2>
              <div className="about-future">
                <div className="about-future-vision">
                  <h3>O Futuro da Gestão no Food Service</h3>
                  <p>
                    Nossa visão é ser a plataforma de gestão preferida para estabelecimentos de food service em todo o Brasil. Continuaremos a inovar, integrando ainda mais inteligência artificial para prever demandas, otinizar compras e personalizar a experiência do cliente final. O futuro é inteligente, integrado e simples.
                  </p>
                </div>
              </div>
            </section>

            <section id="contact" className="about-section">
              <h2>CONTATO</h2>
              <div className="about-contact">
                <div className="about-contact-intro">
                  <h3>Fale Conosco</h3>
                  <p>
                    Estamos prontos para mostrar como a CripSYS pode transformar a gestão do seu estabelecimento.
                  </p>
                </div>
                
                <div className="about-main-contact">
                  <h4>📞 Agende uma Demonstração</h4>
                  <div className="about-main-contact-info">
                    <div className="about-main-contact-item">
                      <span className="about-contact-label">WhatsApp:</span>
                      <span className="about-contact-value">+55 41 9521-1928</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <div className="about-footer-text">
              <p>
                <strong>
                  Obrigado por conhecer nossa história. Estamos ansiosos para fazer parte da jornada de sucesso do seu negócio!
                </strong>
              </p>
              
              {/* === DADOS EMPRESARIAIS ADICIONADOS AQUI === */}
              <div className="about-business-info">
                <p><strong>Nome empresarial:</strong> CRIPSYS INOVA SIMPLES</p>
                <p><strong>CNPJ:</strong> 62.062.305/0001-85</p>
              </div>

              <p className="about-cta-text">
                Pronto para transformar sua gestão? 
                <Link to="/" className="about-cta-link">Conheça nossos planos</Link>
              </p>
            </div>
          </article>
        </div>
      </main>

      {/* Footer */}
      <footer className="about-footer">
        <div className="about-footer-content">
          <Link to="/" className="about-footer-logo">
            <img src="/logolandingpage.png" alt="CripSYS Logo" />
          </Link>
          <p>&copy; {new Date().getFullYear()} CripSYS.</p>
          <Link to="/" className="about-footer-back">
            Voltar ao Site Principal
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default AboutUs;